
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import TableCellCollapse from './table-cell-collapse'
import TableCollapse from './table-collapse'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "tablecollapse"
    }}>{`TableCollapse`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Tables`}</p>
    <hr />
    <h2 {...{
      "id": "table-collapse"
    }}>{`Table collapse`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For presenting data sets in a structured layout. Headers are styled differently to data;
both use lining figures (Econ Sans).`}</p>
    <Playground __position={1} __code={'<TableCollapse>\n  <thead>\n    <tr>\n      <th scope=\"col\">Column 1</th>\n      <th scope=\"col\">Column 2</th>\n      <th scope=\"col\">Column 3</th>\n      <th scope=\"col\">Column 4</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr>\n      <TableCellCollapse dataLabel=\"Column1\">C1 Row 1</TableCellCollapse>\n      <TableCellCollapse dataLabel=\"Column2\">C2 Row 1</TableCellCollapse>\n      <TableCellCollapse dataLabel=\"Column3\">C3 Row 1</TableCellCollapse>\n      <TableCellCollapse dataLabel=\"Column4\">C4 Row 1</TableCellCollapse>\n    </tr>\n    <tr>\n      <TableCellCollapse dataLabel=\"Column1\">C1 Row 2</TableCellCollapse>\n      <TableCellCollapse dataLabel=\"Column2\">C2 Row 2</TableCellCollapse>\n      <TableCellCollapse dataLabel=\"Column3\">C3 Row 2</TableCellCollapse>\n      <TableCellCollapse dataLabel=\"Column4\">C4 Row 2</TableCellCollapse>\n    </tr>\n    <tr>\n      <TableCellCollapse dataLabel=\"Column1\">C1 Row 3</TableCellCollapse>\n      <TableCellCollapse dataLabel=\"Column2\">C2 Row 3</TableCellCollapse>\n      <TableCellCollapse dataLabel=\"Column3\">C3 Row 3</TableCellCollapse>\n      <TableCellCollapse dataLabel=\"Column4\">C4 Row 3</TableCellCollapse>\n    </tr>\n    <tr>\n      <TableCellCollapse dataLabel=\"Column1\">C1 Row 4</TableCellCollapse>\n      <TableCellCollapse dataLabel=\"Column2\">C2 Row 4</TableCellCollapse>\n      <TableCellCollapse dataLabel=\"Column3\">C3 Row 4</TableCellCollapse>\n      <TableCellCollapse dataLabel=\"Column4\">C4 Row 4</TableCellCollapse>\n    </tr>\n  </tbody>\n</TableCollapse>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      TableCellCollapse,
      TableCollapse
    }} mdxType="Playground">
  <TableCollapse mdxType="TableCollapse">
    <thead>
      <tr>
        <th scope='col'>Column 1</th>
        <th scope='col'>Column 2</th>
        <th scope='col'>Column 3</th>
        <th scope='col'>Column 4</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <TableCellCollapse dataLabel='Column1' mdxType="TableCellCollapse">C1 Row 1</TableCellCollapse>
        <TableCellCollapse dataLabel='Column2' mdxType="TableCellCollapse">C2 Row 1</TableCellCollapse>
        <TableCellCollapse dataLabel='Column3' mdxType="TableCellCollapse">C3 Row 1</TableCellCollapse>
        <TableCellCollapse dataLabel='Column4' mdxType="TableCellCollapse">C4 Row 1</TableCellCollapse>
      </tr>
      <tr>
        <TableCellCollapse dataLabel='Column1' mdxType="TableCellCollapse">C1 Row 2</TableCellCollapse>
        <TableCellCollapse dataLabel='Column2' mdxType="TableCellCollapse">C2 Row 2</TableCellCollapse>
        <TableCellCollapse dataLabel='Column3' mdxType="TableCellCollapse">C3 Row 2</TableCellCollapse>
        <TableCellCollapse dataLabel='Column4' mdxType="TableCellCollapse">C4 Row 2</TableCellCollapse>
      </tr>
      <tr>
         <TableCellCollapse dataLabel='Column1' mdxType="TableCellCollapse">C1 Row 3</TableCellCollapse>
         <TableCellCollapse dataLabel='Column2' mdxType="TableCellCollapse">C2 Row 3</TableCellCollapse>
         <TableCellCollapse dataLabel='Column3' mdxType="TableCellCollapse">C3 Row 3</TableCellCollapse>
         <TableCellCollapse dataLabel='Column4' mdxType="TableCellCollapse">C4 Row 3</TableCellCollapse>
       </tr>
       <tr>
          <TableCellCollapse dataLabel='Column1' mdxType="TableCellCollapse">C1 Row 4</TableCellCollapse>
          <TableCellCollapse dataLabel='Column2' mdxType="TableCellCollapse">C2 Row 4</TableCellCollapse>
          <TableCellCollapse dataLabel='Column3' mdxType="TableCellCollapse">C3 Row 4</TableCellCollapse>
          <TableCellCollapse dataLabel='Column4' mdxType="TableCellCollapse">C4 Row 4</TableCellCollapse>
        </tr>
    </tbody>
  </TableCollapse>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={TableCollapse} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;